import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-print-button',
  templateUrl: './print-button.component.html',
  styleUrls: ['./print-button.component.scss'],
})
export class PrintButtonComponent implements OnInit {
  @Input() data: Array<{ type: string; content: any }>;
  route: any[];
  @Input() printButtonTemplate: TemplateRef<any>;

  constructor() {}

  ngOnInit() {}
  prepareData() {
    const storageData = localStorage.getItem('printdata');
    let printdata = {};
    let newkey = '1';
    if (storageData != null) {
      printdata = JSON.parse(storageData);
      const keys = Object.keys(printdata);
      if (keys.length > 0) {
        newkey = Object.keys(printdata).reduce((acc, x) =>
          parseInt(acc, 10) > parseInt(x, 10) ? acc : x
        );
      }
    }
    printdata[newkey] = this.data.length > 0 ? this.data : {};
    localStorage.setItem('printdata', JSON.stringify(printdata));
    this.route = ['/print', newkey];
  }
}
